import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Input,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { MDBDataTable } from "mdbreact";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as url from "../../../helpers/url_helper";
import "flatpickr/dist/themes/material_blue.css";
import { setBreadcrumbItems } from "../../../store/actions";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import InputColor from "react-input-color";
import Select from "react-select";
const CategoryList = (props) => {
  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "Category List", link: "#" },
  ];
  useEffect(() => {
    onGetCategoryList();
  }, []);
  const [color, setColor] = React.useState({});
  const [categoryList, setCategoryList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [level, setLevel] = useState("");
  const [hexCode, setHexCode] = useState("");
  const [defaultId, setDefaultID] = useState("");
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [categoryDetail, setCategoryDetail] = useState({});
  const [editId, setEditId] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [status, setStatus] = useState("");

  const handleDelete = async (e) => {
    e.preventDefault();
    setShowDeleteModal(false);
    setLoading(true);
    try {
      const response = await fetch(
        url.AUTH_URL + `delete-category/${selectedId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const result = await response.json();
      if (result.status) {
        toast.success("Category Deleted Successfully!");
        setCategoryList((prev) =>
          prev.filter((item) => item._id !== selectedId)
        );
        setLoading(false);
        setShowDeleteModal(false);
      } else {
        toast.error("Update failed.");
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.warn("Something went wrong!");
    }
  };

  function onGetCategoryList() {
    setLoading(true);
    let urlPath = "getCategory";

    fetch(url.AUTH_URL + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.status && responseData.data != undefined) {
          setCategoryList(responseData.data);
        } else {
          toast.error("Something went wrong, Please try again after sometime.");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("err", error);
        toast.error("Something went wrong, Please try again after sometime.");
      })
      .finally((final) => {
        setLoading(false);
      });
  }
  useEffect(() => {
    props.setBreadcrumbItems("List", breadcrumbItems);
  });

  const handleAddSubmit = async (e) => {
    e.preventDefault();
    if (!categoryName || !level || !defaultId || !color.hex) {
      toast.error("Please fill in all fields.");
      return;
    }
    const payload = {
      name: categoryName,
      level: level,
      DefaultId: defaultId,
      Hexcode: color?.hex,
      status: status.value,
    };

    setLoading(true);
    try {
      const response = await fetch(url.AUTH_URL + `/create-category`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result.status) {
        toast.success(result.message);
        setLoading(false);
        setCategoryList((prev) => [...prev, result.data.data]);
        setAddModal(false);
      } else {
        toast.error("Update failed.");
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.warn("Something went wrong!");
    }
  };
  const handleEditSubmit = async (e) => {
    e.preventDefault();
    // if (!categoryName || !level || !defaultId || !hexCode) {
    //   toast.error("Please fill in all fields.");
    //   return;
    // }
    const payload = {
      name: categoryDetail.name,
      level: categoryDetail.level,
      DefaultId: categoryDetail.DefaultID,
      Hexcode: categoryDetail.hexCode,
      status: categoryDetail.status,
    };
    setLoading(true);
    try {
      const response = await fetch(
        url.AUTH_URL + `/update-category/${editId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (result.status) {
        toast.success("Category Updated Successfully!");
        setLoading(false);
        setCategoryList((prev) =>
          prev.map((item) =>
            item._id === editId ? result.category.data : item
          )
        );
        setEditModal(false);
      } else {
        toast.error("Update failed.");
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.warn("Something went wrong!");
    }
  };
  function getCategoryDetails(id) {
    setEditId(id);
    let urlPath = `GetCategoryDetails/${id}`;

    fetch(url.AUTH_URL + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.status) {
          const data = responseData.data;
          setCategoryDetail({
            id: data._id,
            name: data.name,
            status: data.status,
            hexCode: data.HexCode,
            DefaultID: data.DefaultID,
            level: data.level,
          });
        } else {
          toast.error("Something went wrong, Please try again after sometime.");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("err", error);
        toast.error("Something went wrong, Please try again after sometime.");
      })
      .finally(() => {
        setLoading(false);
      });
  }
  const statusOptions = [
    { label: "Active", value: "ACTIVE" },
    { label: "Inactive", value: "INACTIVE" },
  ];
  const formattedCategoryList = categoryList.map((category) => ({
    ...category,
    name: [
      <Link to={"/GetDesignationListByCategory/" + category._id}>
        {category.name}
      </Link>,
    ],
    hexColor: [
      <div
        style={{
          backgroundColor: category.HexCode,
          width: "100px",
          height: "30px",
        }}
      ></div>,
    ],
    hexCode: category.HexCode,
    level: category.level,
    defaultId: category.DefaultID,
    Action: [
      <Link
        onClick={(e) => {
          e.preventDefault();
          setViewModal(true);
          getCategoryDetails(category._id);
        }}
        className="btn btn-info btn-sm "
      >
        {" "}
        <span className="menu-text" style={{ color: "white" }}>
          {" "}
          <span className=" menu-icon fas fa fa-eye" style={{ color: "white" }}>
            {" "}
          </span>
        </span>{" "}
      </Link>,
      <Link
        className="btn btn-warning btn-sm  m-1"
        onClick={(e) => {
          e.preventDefault();
          setEditModal(true);
          getCategoryDetails(category._id);
        }}
      >
        {" "}
        <span className="menu-text" style={{ color: "white" }}>
          {" "}
          <span className="menu-icon fas fa fa-edit" style={{ color: "white" }}>
            {" "}
          </span>
        </span>{" "}
      </Link>,
      <Link
        className="btn btn-danger btn-sm  m-1"
        onClick={(e) => {
          e.preventDefault();
          setSelectedId(category._id);
          setShowDeleteModal(true);
        }}
      >
        {" "}
        <span className="menu-text" style={{ color: "white" }}>
          {" "}
          <span
            className="menu-icon fas fa fa-trash"
            style={{ color: "white" }}
          >
            {" "}
          </span>
        </span>{" "}
      </Link>,
    ],
  }));
  const tableData = {
    columns: [
      {
        label: "Category Name",
        field: "name",
        sort: "asc",
        width: 23,
      },
      {
        label: "Hex Color",
        field: "hexColor",
        sort: "asc",
        width: 10,
      },
      {
        label: "Hex Code",
        field: "hexCode",
        sort: "asc",
        width: 10,
      },
      {
        label: "DefaultID",
        field: "defaultId",
        sort: "asc",
        width: 10,
      },
      {
        label: "Level",
        field: "level",
        sort: "asc",
        width: 10,
      },
      {
        label: "Status",
        field: "status",
        sort: "asc",
        width: 10,
      },
      {
        label: "Action",
        field: "Action",
        sort: "asc",
        width: 20,
      },
    ],
    rows: formattedCategoryList,
  };
  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Col md="9">
                  <CardTitle className="h4 mb-0">Manage Category</CardTitle>
                </Col>
              </CardHeader>
              <CardBody>
                <div className="row">
                  {viewModal && (
                    <Modal
                      size="m"
                      centered
                      show={viewModal}
                      backdrop="static"
                      keyboard={false}
                      onHide={() => setViewModal(false)}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>View Category</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div className="row">
                          <table className="table table-bordered table-striped dataTable">
                            <tbody>
                              <tr>
                                <th>Category Name</th>
                                <td>{categoryDetail.name}</td>
                              </tr>
                              <tr>
                                <th>DefaultID</th>
                                <td>{categoryDetail.DefaultID}</td>
                              </tr>
                              <tr>
                                <th>Hex Code</th>
                                <td>
                                  <div
                                    style={{
                                      backgroundColor: categoryDetail.hexCode,
                                      width: "100px",
                                      height: "30px",
                                    }}
                                  ></div>
                                </td>
                              </tr>
                              <tr>
                                <th>Level</th>
                                <td>{categoryDetail.level}</td>
                              </tr>
                              <tr>
                                <th>Status</th>
                                <td>
                                  <i className="badge bg-success text-white p-2">
                                    {categoryDetail.status}
                                  </i>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          onClick={() => setViewModal(false)}
                        >
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                </div>
                <div className="row">
                  {editModal && (
                    <Modal
                      size="m"
                      centered
                      show={editModal}
                      backdrop="static"
                      keyboard={false}
                      onHide={() => setEditModal(false)}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Update Category</Modal.Title>
                      </Modal.Header>
                      <form onSubmit={handleEditSubmit}>
                        <Modal.Body>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group">
                                <label for="categoryName" class="form-label">
                                  Category Name
                                  <span class="text-danger"> *</span>
                                </label>
                                <Input
                                  classNamePrefix=""
                                  value={categoryDetail.name || ""}
                                  onChange={(e) => {
                                    setCategoryDetail((prev) => ({
                                      ...prev,
                                      name: e.target.value,
                                    }));
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label>
                                  Level<span class="text-danger"> *</span>
                                </label>
                                <Input
                                  classNamePrefix="select2-selection"
                                  value={categoryDetail.level}
                                  onChange={(e) => {
                                    setCategoryDetail((prev) => ({
                                      ...prev,
                                      level: e.target.value,
                                    }));
                                  }}
                                />
                              </div>
                            </div>
                            <div
                              className="col-md-10"
                              style={{
                                display: "flex",
                                "align-items": "center",
                              }}
                            >
                              <div className="col-md-12">
                                <div className="form-group">
                                  <label>
                                    Hex Code<span class="text-danger"> *</span>
                                  </label>
                                  <Input
                                    classNamePrefix="select2-selection"
                                    value={categoryDetail.hexCode}
                                    readOnly="true"
                                    onChange={(e) =>
                                      setCategoryDetail((prev) => ({
                                        ...prev,
                                        hexCode: e.target.value,
                                      }))
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-md-6 mt-2">
                                <InputColor
                                  initialValue={categoryDetail.hexCode || "#5e72e4"}
                                  onChange={(color) =>
                                    setCategoryDetail((prev) => ({
                                      ...prev,
                                      hexCode: color.hex,
                                    }))
                                  }
                                  placement="top-right"
                                  style={{
                                    width: 80,
                                    height: 40,
                                    border: "1px solid #ccc",
                                    borderRadius: 3,
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label>
                                  DefaultId<span class="text-danger"> *</span>
                                </label>
                                <Input
                                  classNamePrefix="select2-selection"
                                  value={categoryDetail.DefaultID}
                                  onChange={(e) => {
                                    setCategoryDetail((prev) => ({
                                      ...prev,
                                      DefaultID: e.target.value,
                                    }));
                                  }}
                                />
                              </div>
                            </div>
                            <div className="mb-3">
                              <div className="form-group">
                                <label className="form-label">Status</label>
                                <Select
                                  classNamePrefix="select2-selection"
                                  options={statusOptions}
                                  value={statusOptions.find(
                                    (opt) => opt.value === categoryDetail.status
                                  )}
                                  onChange={(e) => {
                                    setCategoryDetail((prev) => ({
                                      ...prev,
                                      status: e.value,
                                    }));
                                  }}
                                ></Select>
                              </div>
                            </div>
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="primary" type="submit">
                            Update
                          </Button>
                          <Button
                            variant="secondary"
                            onClick={(e) => setEditModal(false)}
                          >
                            Close
                          </Button>
                        </Modal.Footer>
                      </form>
                    </Modal>
                  )}
                </div>
                <div className="row">
                  {addModal && (
                    <Modal
                      size="m"
                      centered
                      show={addModal}
                      backdrop="static"
                      keyboard={false}
                      onHide={() => setAddModal(false)}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Add Category</Modal.Title>
                      </Modal.Header>
                      <form onSubmit={handleAddSubmit}>
                        <Modal.Body>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group">
                                <label for="categoryName" class="form-label">
                                  Category Name
                                  <span class="text-danger"> *</span>
                                </label>
                                <Input
                                  classNamePrefix=""
                                  value={categoryName}
                                  onChange={(e) => {
                                    setCategoryName(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label>
                                  Level<span class="text-danger"> *</span>
                                </label>
                                <Input
                                  classNamePrefix="select2-selection"
                                  value={level}
                                  onChange={(e) => {
                                    setLevel(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                            <div
                              className="col-md-10"
                              style={{
                                display: "flex",
                                "align-items": "center",
                              }}
                            >
                              <div className="col-md-12">
                                <div className="form-group">
                                  <label>
                                    Hex Code<span class="text-danger"> *</span>
                                  </label>
                                  <Input
                                    classNamePrefix="select2-selection"
                                    value={color.hex}
                                    readOnly="true"
                                    style={{ backgroundColor: "#1f302175" }}
                                    onChange={(e) => {
                                      setColor(e.target.value);
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="col-md-6 mt-2">
                                <InputColor
                                  initialValue="#5e72e4"
                                  onChange={setColor}
                                  placement="top-right"
                                  style={{
                                    width: 80,
                                    height: 40,
                                    border: "1px solid #ccc",
                                    borderRadius: 3,
                                  }}
                                />
                              </div>
                            </div>                            
                            <div className="col-md-12">
                              <div className="form-group">
                                <label>
                                  DefaultId<span class="text-danger"> *</span>
                                </label>
                                <Input
                                  classNamePrefix="select2-selection"
                                  value={defaultId}
                                  onChange={(e) => {
                                    setDefaultID(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="mb-3">
                              <div className="form-group">
                                <label className="form-label">Status</label>
                                <Select
                                  classNamePrefix="select2-selection"
                                  options={statusOptions}
                                  value={status}
                                  onChange={(e) => {
                                    setStatus(e);
                                  }}
                                ></Select>
                              </div>
                            </div>
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="primary" type="submit">
                            Save
                          </Button>
                          <Button
                            variant="secondary"
                            onClick={(e) => setAddModal(false)}
                          >
                            Close
                          </Button>
                        </Modal.Footer>
                      </form>
                    </Modal>
                  )}
                </div>
                <div className="d-flex justify-content-end gap-2 mb-2">
                  <button
                    className="btn btn-primary"
                    onClick={() => setAddModal(true)}
                  >
                    <span className="fa fa-plus me-2"></span>Add Category
                  </button>
                </div>
                <div className="row">
                  <Modal
                    show={showDeleteModal}
                    onHide={() => setShowDeleteModal(false)}
                    centered
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Confirm Delete</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      Are you sure you want to delete this category?
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={() => setShowDeleteModal(false)}
                      >
                        Cancel
                      </Button>
                      <Button variant="danger" onClick={handleDelete}>
                        Yes, Delete
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
                <MDBDataTable responsive striped bordered data={tableData} />
              </CardBody>
              {/* <CardBody> */}
              {/* </CardBody> */}
            </Card>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(CategoryList);
